import {combineReducers} from 'redux'
import auth from './auth'
import allocations from './allocations'
import religions from './religions'
import states from './states'
import politicalAffiliations from './politicalAffiliations'
import settings from './settings'
import stats from './stats'
import userData from './userData'
import { reducer as reduxFormReducer } from 'redux-form'

const rootReducer = combineReducers({
	auth,
	allocations,
	religions,
	states,
	politicalAffiliations,
	settings,
	stats,
	userData,
	form: reduxFormReducer
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/redux/reducers/rootReducer.js